"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readFileAsText = exports.readFileAsDataURL = void 0;
var readFile = function readFile(methodName) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  var reader = new FileReader();
  return {
    cancel: function cancel() {
      if (reader.readyState === FileReader.LOADING) {
        reader.abort();
      }
    },
    promise: new Promise(function (resolve, reject) {
      reader.onabort = function () {
        return reject(null);
      };
      reader.onerror = function () {
        return reject(reader.error);
      };
      reader.onload = function () {
        return resolve(reader.result);
      };
      reader[methodName].apply(reader, params);
    })
  };
};
var readFileAsDataURL = exports.readFileAsDataURL = function readFileAsDataURL(file) {
  return readFile('readAsDataURL', file);
};
var readFileAsText = exports.readFileAsText = function readFileAsText(file) {
  var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UTF-8';
  return readFile('readAsText', file, encoding);
};
//# sourceMappingURL=file-utils.js.map